module.exports = __webpack_public_path__ + "img/ks-Income-Protection-Plan-Sales-Tool-pdf.51126088.jpeg";